import { createAxiosInstance } from "~/plugins/axios.plugin";

class UploadService {
  constructor() {
    this.client = createAxiosInstance({ baseURL: process.env.PLATAFORMA_API_V2, useAccessToken: true });
  }

  getCorrectionSignature({ academicMainId, correctionId, fileType, enrollmentTaskAttachmentId, isLegacy }) {
    return this.client.get(`/content/academics-main/${academicMainId}/corrections/${correctionId}/signatures?fileType=${fileType}&enrollmentTaskAttachmentId=${enrollmentTaskAttachmentId}&isLegacy=${isLegacy}`);
  }
};

export default new UploadService();
